<template>
  <div class="category-row">
    <CategoryAchievementRing
        v-for="(cat) in categories"
        :key="cat.category.name"
        :film_ids="film_ids(cat)"
        :category="cat.category"
        :ceremony="ceremony"
        size="50px"
        :disabled="disabled"
    >
    </CategoryAchievementRing>
  </div>
</template>


<script>
import CategoryAchievementRing from "@/components/achievements/CategoryAchievementRing.vue";

export default {
  name: "CeremonyCardRow",
  components: {CategoryAchievementRing},
  props: ['ceremony', 'categories', 'disabled'],
  methods: {
    film_ids(cat) {
      return cat.films
          .filter(film_obj => !film_obj.unofficial_nom)
          .map(film_obj => film_obj.film_id);
    }
  }
}
</script>


<style scoped>
.category-row {
  /*
  border: solid;
  border-color: lightgreen;
  border-width: 1px;
   */

  position: relative;
  text-align: center;
}
</style>